import { useMemo } from "react";
import { isMock, type RuntimeConfig } from "../config";
import { MOCK_PASSKEYS } from "../mocks/fixtures";
import { cognitoApi, type CognitoApi, type PasskeyRecord } from "./cognito-api";

/** The Cognito browser client, or in mock builds one that answers from fixtures so the Security page can be walked. */
export function useCognitoApi(config: RuntimeConfig): CognitoApi {
  return useMemo(() => (isMock ? mockCognitoApi() : cognitoApi(config)), [config]);
}

function mockCognitoApi(): CognitoApi {
  const passkeys: PasskeyRecord[] = [...MOCK_PASSKEYS];
  const fresh = () => ({ AuthenticationResult: { IdToken: "mock.e30=", AccessToken: "mock", ExpiresIn: 3600 } });
  const delay = <T,>(v: T) => new Promise<T>((r) => setTimeout(() => r(v), 30));
  return {
    listPasskeys: () => delay({ Credentials: passkeys }),
    startPasskey: () => delay({ CredentialCreationOptions: {} }),
    completePasskey: () => delay({}),
    deletePasskey: (_t, id) => {
      const i = passkeys.findIndex((p) => p.CredentialId === id);
      if (i >= 0) passkeys.splice(i, 1);
      return delay({});
    },
    changePassword: () => delay({}),
    associateSoftwareToken: () => delay({ SecretCode: "JBSWY3DPEHPK3PXP" }),
    verifySoftwareToken: (_t, code) => delay({ Status: code === "123456" ? "SUCCESS" : "ERROR" }),
    setTotpPreference: () => delay({}),
    globalSignOut: () => delay({}),
    initiateAuth: (_u, preferred, password) => delay(preferred === "PASSWORD" && password ? { ChallengeName: "SOFTWARE_TOKEN_MFA", Session: "s" } : { ChallengeName: "WEB_AUTHN", Session: "s", ChallengeParameters: { CREDENTIAL_REQUEST_OPTIONS: "{}" } }),
    respondToChallenge: () => delay(fresh()),
  };
}
